import { render, staticRenderFns } from "./ReportChart.vue?vue&type=template&id=0627a0ed&scoped=true"
import script from "./ReportChart.vue?vue&type=script&lang=js"
export * from "./ReportChart.vue?vue&type=script&lang=js"
import style0 from "./ReportChart.vue?vue&type=style&index=0&id=0627a0ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0627a0ed",
  null
  
)

export default component.exports